import { graphql, Link, useStaticQuery } from 'gatsby'
import React from 'react'
import { Container } from 'starterUiComponents'
import PdfFirebaseUrlParser from '../../utils/pdf-firebase-url-parser'


const BULLETINS_QUERY = graphql`
  query {
    allMysqlBulletin(
      sort: { fields: [displaytextlink], order: ASC }
    ) {
      nodes {
        calledby
        displaytextlink
        displaytextheader
        id
        returntotext2
        dataUrl
        is_quick_reference
      }
    }
  }
`

const QuickReferencesPage = () => {
  /**
   * Gets all the quick references pdfs
   * @returns array
   */
  const getQuickReferences = () => {
    return allData.filter((item) => {
      return (
        !!item.is_quick_reference
      )
    })
  }

  const allData = useStaticQuery(BULLETINS_QUERY).allMysqlBulletin.nodes
  const quickReferences = getQuickReferences()

  return (
    <Container>
      <h1>Tech Library Quick References</h1>
      <div>
        <ul>
          {quickReferences &&
            quickReferences.map((reference) => {
              const rel = PdfFirebaseUrlParser.getUrl(reference.dataUrl)
              const pdfLink = `/files/quick-references/${rel}`
              return (
                <li key={reference.id}>
                  <Link to={pdfLink}>{reference.displaytextheader}</Link>
                </li>
              )
            })}
        </ul>
      </div>
    </Container>
  )
}

export default QuickReferencesPage
